import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetHfComorbiditiesByPatientIdOptions } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { AddDiags } from "../diagnoses/add-diags";
import { AddDiagsTable } from "../diagnoses/add-diags-table";
import { DiagnosesTable } from "../diagnoses/diagnoses-table";
import { Patient } from "../patient";

export const VisitComorbiditiesSection = observer(
  function VisitComorbiditiesSection(props: {
    app: AppModel;
    patient: Patient;
    onSaved?: () => void | Promise<void>;
  }) {
    const { app, patient, onSaved } = props;
    const [addModel, setAddModel] = useState<AddDiags | null>(null);

    const { data: response, refetch } = useQuery(
      apiGetHfComorbiditiesByPatientIdOptions({
        path: { patient_id: patient.patientId },
      }),
    );
    const data = response?.diagnoses ?? [];

    function openAdd() {
      const m = new AddDiags(patient.api, patient);
      m.addItem();
      setAddModel(m);
    }

    return (
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold">
            <Trans>Current comorbidities</Trans>
          </span>
          <Button size="sm" icon={Plus} onClick={openAdd}>
            <Trans>Add comorbidity</Trans>
          </Button>
        </div>

        <DiagnosesTable
          api={patient.api}
          patient={patient}
          data={data}
          disableEdit
          disableHistory
          disablePagination
        />

        <Dialog
          open={addModel != null}
          onOpenChange={(open) => {
            if (!open) setAddModel(null);
          }}
        >
          <DialogHeader>
            <Trans>Add comorbidities</Trans>
          </DialogHeader>
          <DialogBody>
            {addModel && (
              <AddDiagsTable
                app={app}
                model={addModel}
                onSaved={() => {
                  setAddModel(null);
                  void refetch();
                  void onSaved?.();
                }}
              />
            )}
          </DialogBody>
        </Dialog>
      </div>
    );
  },
);
